'use client'

import Image from "next/image";
import { useTheme } from "tamagui";

export function ExtraLogo({ ...props }) {
	return (
		<svg viewBox="0 0 1453 226"  width={1453 / 10} height={226 / 10} {...props}>
			<g stroke="var(--color)" fill="var(--color)">
				<path d="M435.3,119.7l-25,25.6l82.8,80.5H544L435.3,119.7z"></path>
				<path d="M828.7,141.2h140.9l45.5,84.6h40.3l-47.1-87.8c15.5-4,26-11.3,32.6-17.9c12.4-12.3,19.2-29.2,19.2-47.8
					c0-34.2-24.7-71.2-64.4-71.2C993.1,1.1,793.2,1,793.2,1v224.8h35.5V141.2z M828.7,36.8h159.5l7.6,0.1c17.9,0,28.9,18.4,28.9,35.7
					c0,6.3-1.5,15.3-8.7,22.4c-7.1,6.9-18.7,10.7-33.4,10.7H828.7V36.8z"></path>
				<path d="M1205.3,59.8c7.6-14,22.1-23.4,38.1-23.4h39.4c16,0,30.6,8.7,38.2,22.8l38.2,66.7h-167.7l-19.3,35.6h206.6l33,64.5h40.4
					l-99.9-184.1c-13.7-25.5-40.4-41.3-69.4-41.3h-0.2h-39.2c-28.9,0.2-55.5,16-69.2,41.5L1074.4,226h40.7L1205.3,59.8z"></path>
				<path d="M666.4,38.1h90.9V1H562.9C473,1,417.1,57.3,370.5,106.5c-41.6,43.9-77.5,83.6-135.6,83.6h-178c-11.6,0-21-9.2-21-20.5
					l0.2-39.9h223.1V94.2H36.2l0.2-37c0-11.3,9.2-20.7,20.7-20.7h220.7V0.8H56.8C26,0.8,0.5,26.2,0.5,57v112.4
					c0,31,25.2,56.2,56.3,56.2h178c73.3,0,118.2-48.9,161.4-94.8c45.8-48.4,89.1-92.8,166.6-92.8h68v187.7h35.5V38.1z"></path>
			</g>
		</svg>
	)
}
